import { useState, useEffect } from 'react'
import { WifiOff } from 'lucide-react'

export function OfflineBanner() {
  const [offline, setOffline] = useState(!navigator.onLine)

  useEffect(() => {
    const on  = () => setOffline(false)
    const off = () => setOffline(true)
    window.addEventListener('online',  on)
    window.addEventListener('offline', off)
    return () => { window.removeEventListener('online', on); window.removeEventListener('offline', off) }
  }, [])

  if (!offline) return null

  return (
    <div style={{
      position:'fixed', top:0, left:0, right:0, zIndex: 'var(--z-top)',
      background:'color-mix(in srgb, var(--state-bad) 92%, transparent)', backdropFilter:'blur(8px)',
      padding:'10px 16px',
      paddingTop: 'calc(10px + env(safe-area-inset-top))',
      display:'flex', alignItems:'center', justifyContent:'center', gap:8,
      fontFamily:'var(--font)',
    }}>
      <WifiOff size={14} color="#fff"/>
      <span style={{ color:'var(--text-strong)', fontSize:13, fontWeight:600 }}>No internet connection</span>
    </div>
  )
}
